module.exports = __webpack_public_path__ + "img/12_68.be8f85de.png";